import { Kaggle, usersClient } from "./sdk";

import User = Kaggle.Sdk.Users.Models.User;

let currentUserPromise: Promise<User> | undefined;
/*
 * Lazily fetches the user and caches the response so callers may use this
 * method any time they need, worry-free.
 *
 * Intended to replace the old Current variable in Kaggle.Web.
 */
export const getCurrentUser = (): Promise<User> => {
  if (!currentUserPromise) {
    currentUserPromise = usersClient.getCurrentUser({ includeGroups: false });
  }
  return currentUserPromise;
};
